import { createReducer } from '../utils';
import {
  GENERATE_SNAPSHOT_TIMELINE,
  ADD_SNAPSHOT_TIME,
  SET_SNAPSHOT_TIMELINE_INDEX,
  SET_INITIAL_TIMESTAMP,
  UPDATE_SNAPSHOT_TIMELINE_COUNT,
  SNAPSHOT_TIMESTAMP_REMOVED,
} from '../constants';

const initialState = {
  isFetching: false,
  timeline: [],
  camId: null,
  shareType: '',
  timestampIndex: null,
  initialTimestamp: null,
  direction: 'forward',
  count: 0,
  removedToggle: false,
  snapshotMap: null,
};

export default createReducer(initialState, {
  [GENERATE_SNAPSHOT_TIMELINE]: (state, payload) => {
    return Object.assign({}, state, {
      timeline: payload.timeline,
      timestampIndex: payload.timestampIndex,
      snapshotMap: payload.snapshotMap,
    });
  },
  [ADD_SNAPSHOT_TIME]: (state, payload) => {
    const newTime = state.timeline;

    if (payload.direction === 'back') {
      newTime.unshift(payload.timeline);
    } else {
      newTime.push(payload.timeline);
    }

    return Object.assign({}, state, {
      timeline: newTime,
    });
  },
  [SET_SNAPSHOT_TIMELINE_INDEX]: (state, payload) => {
    return Object.assign({}, state, {
      timestampIndex: payload.index,
      direction: payload.direction,
    });
  },
  [SET_INITIAL_TIMESTAMP]: (state, payload) => {
    return Object.assign({}, state, {
      initialTimestamp: payload.timestamp,
      count: 0,
    });
  },
  [UPDATE_SNAPSHOT_TIMELINE_COUNT]: (state, payload) => {
    const count = state.count + payload.value;
    return Object.assign({}, state, { count });
  },
  [SNAPSHOT_TIMESTAMP_REMOVED]: (state) => {
    return Object.assign({}, state, {
      removedToggle: !state.removedToggle,
    });
  },
});
